import { Heart as FeatherHeart } from 'react-feather';
import { Tooltip } from 'antd';
import TooltipText from 'components/common/TooltipText';
import { iconStyles } from 'styles/theme';
import styled from '@emotion/styled';

type Props = {
  selected?: boolean;
  onSelect?: () => void;
};

export default function HeartIconContainer(props: Props): JSX.Element {
  const { selected, onSelect } = props;

  const ariaLabel = selected
    ? 'This credit is marked as saved. Click again to unsave it.'
    : 'This credit is not marked as saved. Click to save it to the saved list.';
  return (
    <Container onClick={onSelect} aria-label={ariaLabel}>
      <Tooltip placement='bottom' title={<TooltipText>{selected ? 'Remove from saved' : 'Save'}</TooltipText>}>
        <HeartIcon size={18} className={selected ? 'heart-icon-filled' : 'heart-icon-outline'} selected={!!selected} />
      </Tooltip>
    </Container>
  );
}

const Container = styled.button({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  position: 'relative',
  bottom: 9,
  left: 9,
  background: 'none',
  border: 'none',
  padding: 0,
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: '#ECECEE',
    borderRadius: '50%',
    cursor: 'pointer',
  },
});

export const HeartIcon = styled(FeatherHeart)<{ selected: boolean }>((props) => ({
  color: props.selected ? iconStyles.colors.primary : iconStyles.colors.secondary,
  fill: props.selected ? iconStyles.colors.secondary : undefined,
}));
